module.exports = __webpack_public_path__ + "img/feature_buy_cn.0eb789d5.png";